import type { Layer } from './Layer'
//import type maplibregl from 'maplibre-gl'

/**
 * Interface pour une couche OSM provenant du serveur Martin
 */
export interface OsmLayer extends Layer {
  /**
   * Nom de la table dans la base de données PostgreSQL
   */
  tableName: string

  /**
   * Type de géométrie de la couche
   */
  geometryType: 'point' | 'line' | 'polygon' | 'roads' | 'ways' | 'nodes' | 'users'

  /**
   * URL de base du serveur Martin (optionnel, peut être défini globalement)
   */
  martinUrl?: string

  /**
   * Style par défaut de la couche
   */
  defaultStyle?: {
    paint?: {
      'line-color'?: string
      'line-width'?: number
      'line-opacity'?: number
      'fill-color'?: string
      'fill-opacity'?: number
      'circle-color'?: string
      'circle-radius'?: number
      'circle-opacity'?: number
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    layout?: any //maplibregl.Layout
  }

  /**
   * Filtre SQL optionnel pour filtrer les données côté serveur
   */
  filterSql?: string

  /**
   * ID de la catégorie OSM (optionnel, utilisé pour le filtrage)
   */
  categoryId?: number
}

/**
 * Configuration des couches OSM disponibles
 * Note: Cette configuration peut être vide si les couches sont chargées dynamiquement depuis l'API
 */
export const OSM_LAYERS_CONFIG: OsmLayer[] = []
